import { jsx as l } from "react/jsx-runtime";
import { T as a } from "../../../vendor--aJiswR_.js";
import '../../../assets/index43.css';const t = "_label_1bz3m_1", o = {
  label: t
};
function m({ children: e }) {
  return /* @__PURE__ */ l(a, { elementType: "span", slot: "label", className: o.label, children: e });
}
export {
  m as ItemLabel
};
//# sourceMappingURL=index.js.map
